import PropTypes from 'prop-types';

const SocialLoginData = (props) => {
  const { loginData } = props;
  return loginData ? JSON.stringify(loginData) : '-';
};

SocialLoginData.propTypes = {
  loginData: PropTypes.shape({}),
};

SocialLoginData.defaultProps = {
  loginData: null,
};

export default SocialLoginData;
